export class OneSignalConstants {
	public static readonly PUBLICKEY = '266eca2c-8cf5-49d6-80b3-a8ad3c52d3e1'
	public static readonly APPID = '1096519840558'
};